import React from 'react'
import Message from 'views/components/presentationals/Message'
import { FormattedMessage } from 'react-intl'

export const TemporaryMessage = () => {
  const message = `pages.temporaryMessage` // Update the message to display in yaml

  const shouldDisplay = false // Add roles on which display the message and set to false otherwise
  // const shouldDisplay = useIsGranted(false, [TYPES.FREIGHT_FORWARDER])

  return (
    <>
      {shouldDisplay && (
        <Message brand="info" withBorderRadius>
          <FormattedMessage id={message} />
        </Message>
      )}
    </>
  )
}
